import { TrendingUp, Trophy, Handshake, Flame } from "lucide-react";
import { VALUES, ASSETS } from "@/lib/constants";
import { Reveal } from "@/components/Reveal";
import { BlazerWay } from "@/components/BlazerWay";

const ICONS = { "trending-up": TrendingUp, trophy: Trophy, handshake: Handshake, flame: Flame };

export function About() {
  return (
    <section id="about" className="relative py-20 sm:py-28 lg:py-32 bg-ink-900 overflow-hidden">
      <div className="absolute inset-0 court-glow opacity-60" />
      <div className="container-x relative">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-3 rounded-3xl bg-gradient-to-br from-blaze-blue/30 to-blaze-orange/20 blur-2xl opacity-60" />
              <img
                src={ASSETS.clinicGroup}
                alt="CT Blazers coaches and youth basketball players at a Norwalk clinic"
                className="relative rounded-2xl border border-white/10 w-full object-cover aspect-[4/3] shadow-2xl"
              />
              <div className="absolute -bottom-5 -right-5 hidden sm:block rounded-xl bg-blaze-orange text-ink-900 px-5 py-4 shadow-xl">
                <div className="font-heading text-4xl leading-none">10U–17U</div>
                <div className="text-xs font-bold uppercase tracking-wider">Boys & Girls</div>
              </div>
            </div>
          </Reveal>

          <div>
            <Reveal>
              <span className="text-xs font-bold uppercase tracking-[0.3em] text-blaze-orange">Who We Are</span>
              <h2 className="mt-3 font-display font-black uppercase tracking-tight text-4xl sm:text-5xl text-white leading-none">
                About CT <span className="text-gradient-blaze">Blazers</span>
              </h2>
              <p className="mt-6 text-lg text-white/75 leading-relaxed border-l-2 border-blaze-orange pl-5">
                CT BLAZERS is a Norwalk, CT based program established in 2019. Our mission is to provide boys and girls
                who are enthusiastic about basketball a great learning experience! Our knowledgeable coaches are
                passionate and take tremendous pride in developing players. We balance individual skill work with team
                concepts, so every player grows into themselves and learns the game the right way!! This is all done in a
                safe, family oriented environment!
              </p>
            </Reveal>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              {VALUES.map((v, i) => {
                const Icon = ICONS[v.icon];
                return (
                  <Reveal key={v.title} delay={i * 0.08}>
                    <div
                      data-testid={`value-${i}`}
                      className="hover-lift group rounded-xl border border-white/10 bg-ink-700/60 p-5 hover:border-blaze-blueLight/50 hover:bg-ink-600/60"
                    >
                      <div className="grid h-11 w-11 place-items-center rounded-lg bg-blaze-blue/15 text-blaze-blueLight group-hover:bg-blaze-orange/20 group-hover:text-blaze-orange transition-colors">
                        <Icon size={22} />
                      </div>
                      <h3 className="mt-4 font-heading text-xl tracking-wide text-white uppercase">
                        {v.blazerWay ? <BlazerWay /> : v.title}
                      </h3>
                      <p className="mt-1.5 text-sm text-white/60 leading-relaxed">{v.desc}</p>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
